<template lang="pug">
.label(v-if="label") {{ label }}
FormField(v-slot="$field" :name="name")
  Select.w-full(
    v-model="$field.value"
    :options="dropdownOptions"
    placeholder="All Counselors"
    filter 
    optionLabel="name"
    optionValue="code"
    showClear
  )
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Select        from 'primevue/select';
import Message       from 'primevue/message';
import { FormField } from '@primevue/forms';
import { dropdownOptionsApi }   from '@/api'

const dropdownOptions = ref([])

const props = defineProps({
  name:   { type: String, required: true,  default: 'fieldName' },
  label:  { type: String, required: false, default: 'field' },
  includeInactive: { type: Boolean, required: false, default: false },
})

onMounted(() => {
  const params = props.includeInactive ? {includeInactive: true} : null
  dropdownOptionsApi.getDestinationCounselors(params)
    .then(response => {
      dropdownOptions.value = response.data
    })
})
</script>